import './gallery-image-and-text.scss'
import { ImageWithFocalPoint } from '@omnia/ui/src/lib/cms'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'
import type { GalleryImageAndTextPropsApi } from '@/features/grid/galleryImageAndText/models'

export const GalleryImageAndText: FC<GridElement<GalleryImageAndTextPropsApi[]>> = props => {
    return (
        <div className="gallery">
            {props.value.map((item, index) => (
                <div className="gallery__item" key={index}>
                    {item.image && (
                        <ImageWithFocalPoint
                            {...item.image}
                            className="gallery__item__image"
                            dimensions={{
                                width: 500,
                                tablet: {
                                    width: 400,
                                },
                                mobile: {
                                    width: 800,
                                },
                                portrait: {
                                    width: 500,
                                },
                            }}
                        />
                    )}
                    {item.heading && <h2 className="gallery__item__heading">{item.heading}</h2>}
                    {item.subHeading && <h3 className="gallery__item__subheading">{item.subHeading}</h3>}
                    {item.description && <p className="gallery__item__text">{item.description}</p>}
                </div>
            ))}
        </div>
    )
}
